import { type UseApiHook } from '@/hooks/useApi'
import { sessionFreshenSpec } from 'aevocam-rest-api-spec'

/** Either connect to the current session or start a new one */
export async function sessionFreshen(
  api: UseApiHook,
  tenantId: string | undefined
) {
  try {

    const res = await api.request(sessionFreshenSpec, {
      path: {
        tenant: tenantId?.toString() ?? '',
      },
    })

    if (res.status === 404 && res.error === 'Tenant not found') {
      console.error('Tenant not found')
      if (window.location.pathname.match(/^\/t\/\d+(\/|$)/)) {
        window.location.href = '/'
      }
      return
    }

    const session = res.data!
    if (!session) {
      console.error('No session returned from sessionFreshen:', res)
      return
    }

    if (session.sessionId) {
      localStorage.setItem('sessionId', session.sessionId)
    } else {
      localStorage.removeItem('sessionId')
    }

    api.setStatus({
      ...api.status,
      initialized: true,
      session,
      // Did the server (and client) version change?
      ...(
        (
          api.status.session?.refreshVersion &&  // Unknown until first call
          session.refreshVersion !== api.status.session?.refreshVersion
        )
        ? { needsRefresh: true }
        : {}
      ),
    })
  } catch (error) {
    console.error(error)
  }
}
